import React from 'react';
import { useEffect, useState, useRef, useCallback } from "react";
import { Col, Row } from "reactstrap";
import { useMediaQuery } from "react-responsive";
import { APILA } from "../../../../../config/apila";
import { APIMS } from "../../../../../config/apims";
import "bulma/css/bulma.css";
import "../../../../../index.css";
import swal from "sweetalert";
import LoaderHome from "../../../../Loader/LoaderHome";
import { useLocation, useNavigate, Link } from "react-router-dom";
import Tab from "react-bootstrap/Tab";
import Tabs from "react-bootstrap/Tabs";
import ToastError from "../../../../NotificationToast/ToastError";
import ToastSuccess from "../../../../NotificationToast/ToastSuccess";
import HeadPage from "./component/HeadPage";
import { faLock } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { PulseLoader} from "react-spinners";
import Confirm from './modal/confirmNilaiHead';
import CancelNilai from './modal/cancelNilaiHead';
import { faKey } from '@fortawesome/free-solid-svg-icons';

/* ===========================
   🔥 SKELETON SHIMMER STYLE
=========================== */
const shimmerStyle = `
  @keyframes shimmer {
    0% { background-position: -468px 0; }
    100% { background-position: 468px 0; }
  }
  .shimmer {
    animation-duration: 1.2s;
    animation-fill-mode: forwards;
    animation-iteration-count: infinite;
    animation-timing-function: linear;
    animation-name: shimmer;
    background: #f6f7f8;
    background: linear-gradient(
      to right,
      #ddeaffff 8%,
      #f4f8ffff 18%,
      #ddeaffff 33%
    );
    background-size: 800px 104px;
  }
  .shimmer-select {
    height: 35px;
    border-radius: 4px;
  }
  .shimmer-row {
    height: 38px;
  }
  `;

export default function NilaiKepsek() {
  document.title = "Penilaian Kepala Sekolah";

  const [page] = useState(1);
  const [limit] = useState(1000);
  const [ascending] = useState(1);
  const [descending] = useState(0);
  const [keyword, setKeyword] = useState("");
  const token = localStorage.getItem("token");

  const isTabletOrMobile = useMediaQuery({ query: "(max-width: 780px)" });
  const [loading, setLoading] = useState(false);
  const [loadingSchool, setLoadingSchool] = useState(false);
  const firstLoadDone = useRef(false);

  const storageBranchGroping = localStorage.getItem("ysb_branch_id");
  const storageLevel = localStorage.getItem("level");
  const ysbRoleName = localStorage.getItem("ysb_role_name");
  const isPengawasAdab = ysbRoleName === "Pengawas Adab";

  /* DATA STATES */
  const [getDataBranch, setGetDataBranch] = useState([]);
  const [getDataSchool, setGetDataSchool] = useState([]);
  const [getDataSemester, setGetDataSemester] = useState(null);
  const [getDataSemesterMap, setGetDataSemesterMap] = useState([]);
  const [getDataDimensi, setGetDataDimensi] = useState([]);
  const [getData, setGetData] = useState([]);

  const [hasSearched, setHasSearched] = useState(false);
  const [isFirstLoad, setIsFirstLoad] = useState(true);
  const [isFilterDirty, setIsFilterDirty] = useState(false);
  const [selectedTab, setSelectedTab] = useState(null);
  const [isFetching, setIsFetching] = useState(false);

  const id_user = localStorage.getItem("id_admin");
  const output_id_user = id_user.replace(/[|&;$%@"<>()+,]/g, "");

  const [namaTA, setNamaTA] = useState("");
  const [namaSmstr, setNamaSmstr] = useState("");

  const navigate = useNavigate();
  const location = useLocation();

  /* ====================================== PERMISSION ====================================== */
  const [permission, setPermission] = useState({
    create: 0,
    read: 0,
    update: 0,
    delete: 0,
  });

  useEffect(() => {
    const storageLevel = localStorage.getItem("level");
    const storageItems =
      JSON.parse(localStorage.getItem("role_permission")) || [];

    if (
      storageLevel === "developer" ||
      storageLevel === "superadmin"
    ) {
      setPermission({ create: 1, read: 1, update: 1, delete: 1 });
    } else {
      const found = storageItems.find(
        (item) => item.menu?.url === location.pathname
      );
      if (!found) navigate("/dashboard");
      else setPermission(found);
    }
  }, [location.pathname, navigate]);

  /* ====================================== FORM STATES ====================================== */

  const [form2, setForm2] = useState({
    ysb_semester_id: "",
    ysb_dimensi_id: "",
    ysb_branch_id: "",
    ysb_school_id: "",
  });

 const isFilterComplete =
  isFilterDirty &&
  !!form2.ysb_semester_id &&
  !!form2.ysb_branch_id &&
  !!form2.ysb_school_id &&
  !!form2.ysb_dimensi_id;



  /* API HEADERS */
  const fetchParams = {
    headers: {
      Authorization: `${token}`,
      "Content-Type": "application/json",
    },
  };

  const isMounted = useRef(true);
  const abortControllers = useRef([]);

  useEffect(() => {
    return () => {
      isMounted.current = false;
      abortControllers.current.forEach((c) => c.abort());
    };
  }, []);

  const sortSchools = (schools) => {
    const order = ["SD", "SMP", "SMA"];

    return [...schools].sort((a, b) => {
      const jenjangA = order.findIndex(j => a.school_name.toUpperCase().includes(j));
      const jenjangB = order.findIndex(j => b.school_name.toUpperCase().includes(j));

      return jenjangA - jenjangB;
    });
  };

  const removeBasementBekasi = (schools, branchId) => {
    if (branchId === "BKS") {
      return schools.filter(
        (s) => s.school_code !== "BASEMENT_BEKASI"
      );
    }
    return schools;
  };


  /* =============================================================================================== */
  /* ===============================  FETCH INIT (BRANCH, SCHOOL, SEMESTER, DIMENSI)  ============= */
  /* =============================================================================================== */

  const fetchInit = useCallback(async () => {
    setLoading(true);
    const controller = new AbortController();
    abortControllers.current.push(controller);

    try {
      const [branchRes, semesterRes, dimensiRes] = await Promise.all([
        APIMS.get(
          `/api/access/branches?page=${page}&limit=${limit}&ascending=${ascending}&search=${keyword}&branch=${storageBranchGroping}&level=${storageLevel}`,
          { ...fetchParams, signal: controller.signal }
        ),
        // APILA.get(
        //   `/api/access/semesters?page=${page}&limit=${limit}&ascending=${descending}&search=${keyword}`,
        //   { ...fetchParams, signal: controller.signal }
        // ),
        APIMS.get(
          `/api/access/semesters?page=${page}&limit=${limit}&ascending=${descending}&search=${keyword}`,
          { ...fetchParams, signal: controller.signal }
        ),
        APILA.get(
          `/api/access/dimensis?page=${page}&limit=${limit}&ascending=${ascending}&search=${keyword}`,
          { ...fetchParams, signal: controller.signal }
        ),
      ]);

      if (!isMounted.current) return;

      /* ------------------- SET DATA BRANCH ------------------- */
      if (branchRes?.status === 200) {
        const branches = branchRes.data.data || [];
        setGetDataBranch(branches);

        if (branches.length > 0) {
          const firstBranch = branches[0].branch_code;

          setForm2((prev) => ({
            ...prev,
            ysb_branch_id: firstBranch,
          }));

        }
      }

      /* ------------------- SET SEMESTER ------------------- */
      if (semesterRes?.status === 200) {
        const semesters = semesterRes.data.data || [];
        const active = semesters.find((s) => s.status === 1);

        setGetDataSemester(active || null);
        setGetDataSemesterMap(semesters);

        if (active) {
          setNamaTA(active.name_year);
          setNamaSmstr(active.semester);

          setForm2((prev) => ({
            ...prev,
            ysb_semester_id: active.id,
          }));
        }
      }

      /* ------------------- SET DIMENSI ------------------- */
      if (dimensiRes?.status === 200) {
        const dims = (dimensiRes.data.data || []).filter(
          (d) => d.status === 1
        );
        setGetDataDimensi(dims);

        if (dims.length > 0) {
          setForm2((prev) => ({
            ...prev,
            ysb_dimensi_id: dims[0].id,
          }));
        }
      }

    } catch (err) {
      swal({
        title: "Failed",
        text:
          err?.response?.data?.message ||
          err.message ||
          "Error",
        icon: "error",
      });
    } 
  }, [ascending, descending, keyword, limit, page, storageBranchGroping, storageLevel]);

  useEffect(() => {
    fetchInit();
  }, [fetchInit]);

  /* =============================================================================================== */
  /* ===============================  FETCH DATA CONFIG =========================================== */
  /* =============================================================================================== */

  const GetResponseData = async () => {
    if (isFetching) return; 
    try {
      if (
        !form2.ysb_semester_id ||
        !form2.ysb_branch_id ||
        !form2.ysb_school_id ||
        !form2.ysb_dimensi_id
      )
        return;

      const res = await APILA.get("/api/element-recaps-dimensi/head", {
        params: {
          ysb_semester_id: form2.ysb_semester_id,
          branch: form2.ysb_branch_id,
          ysb_dimensi_id: form2.ysb_dimensi_id,
          ysb_school_id: form2.ysb_school_id,
          level: storageLevel,
        },
        ...fetchParams,
      });
 
      if (res?.status === 200) {
        setGetData(res.data.data);
      }
    } catch (err) {
      swal({
        title: "Failed",
        text: err?.response?.data?.message || "Terjadi kesalahan",
        icon: "error",
      });
    }
  };



     /* ======================= 🔥 AUTO SELECT TAB ======================= */
    useEffect(() => {
      if (
        getData.length > 0 &&
        getData[0]?.data_element?.length > 0 &&
        !selectedTab
      ) {
        setSelectedTab(getData[0].data_element[0].name_element);
      }
    }, [getData, selectedTab]);
  
    // FIRST LOAD 
    useEffect(() => {
      if (
        isFirstLoad &&
        form2.ysb_semester_id &&
        form2.ysb_branch_id &&
        form2.ysb_school_id &&
        form2.ysb_dimensi_id
      ) {
          setIsFetching(true);                
          GetResponseData().finally(() => {
            setIsFetching(false);             
          });
    
          setHasSearched(true); 
          setIsFirstLoad(false); 
          setIsFilterDirty(false); 
        }
    }, [
          isFirstLoad,
          form2.ysb_semester_id,
          form2.ysb_branch_id,
          form2.ysb_school_id,
          form2.ysb_dimensi_id,
        ]
    );
    

  /* ====================================== FILTER CHANGE ====================================== */

  const handleChange = (e) => {
    const { name, value } = e.target;
    setForm2((prev) => ({ ...prev, [name]: value }));

    if (!isFirstLoad) {
      setIsFilterDirty(true); 
      setHasSearched(false);
    }

  };

  // =========================
  // Fetch sekolah saat branch berubah
  // =========================
  const GetResponseDataSchool = useCallback(
    async (branchId) => {
      setLoadingSchool(true); 
      try {
        const res = await APIMS.get(
          `/api/access/schools?page=${page}&limit=${limit}&ascending=${ascending}&branch=${branchId}&level=${storageLevel}`,
          fetchParams
        );

        if (res?.status === 200) {
          let schools = res.data.data || [];

          if (storageLevel === "developer" || storageLevel === "superadmin") {
            schools = schools.filter(
              (s) => s.ysb_branch_id === branchId
            );
          }

          schools = removeBasementBekasi(schools, branchId);
          schools = sortSchools(schools);

          setGetDataSchool(schools);

          if (schools.length > 0) {
            setForm2(prev => ({
              ...prev,
              ysb_school_id: schools[0].school_code,
            }));
          }
        }
      } catch (err) {
        console.log(err);
      } finally {
        setLoadingSchool(false); 
        setLoading(false);       
      }
    },
    [ascending, limit, page, storageLevel]
  );


  /* Jika branch diganti, fetch school baru */
  useEffect(() => {
    if (form2.ysb_branch_id) {
      GetResponseDataSchool(form2.ysb_branch_id);
    }
  }, [form2.ysb_branch_id, GetResponseDataSchool]);

    /* ======================= RESET TAB WHEN FILTER CHANGE ======================= */
    useEffect(() => {
      setSelectedTab(null);
    }, [
      form2.ysb_semester_id,
      form2.ysb_branch_id,
      form2.ysb_school_id,
      form2.ysb_dimensi_id,
    ]);

  /* =============================================================================================== */
  /* ===============================  BUTTON CARI VALIDATION ====================================== */
  /* =============================================================================================== */

  const handleCari = async () => {
    if (!isFilterComplete) return;

    setSelectedTab(null);

    setGetData([]);
    setHasSearched(false);

    setIsFetching(true);

    try {
      await GetResponseData(); 

      setHasSearched(true);
      setIsFilterDirty(false);
    } finally {
      setIsFetching(false);
    }
  };


  /* =========================
     INPUT NILAI
  ========================== */
  const handleChangeNilaiLocal = (e, elementId, rekap) => {
    const value = e.target.value;
    if (value !== "" && (value < 1 || value > 4)) return;

    setGetData(prev => {
      const copy = JSON.parse(JSON.stringify(prev));
      const el = copy[0].data_element.find(x => x.id === elementId);
      const row = el.rekapan.find(r => r.ysb_sub_element_id === rekap.ysb_sub_element_id);
      row.ysb_sub_element_value = value === "" ? null : value;
      return copy;
    });
  };

  const handleBlurNilai = (e, elementId, rekap) => {
    const raw = e.target.value;
    const value = raw === "" ? null : Number(raw);
    if (value !== null && (value < 1 || value > 4)) return;
    saveNilaiDB(rekap, elementId, value);
  };

  const saveNilaiDB = async (rekap, elementId, value) => {
    if (isPengawasAdab) return; 
    const recapId = rekap.ysb_element_recap_head_id;

    const payload = {
      ysb_sub_element_id: rekap.ysb_sub_element_id,
      ysb_sub_element_value: value,
      ysb_branch_id: form2.ysb_branch_id,
      ysb_school_id: form2.ysb_school_id,
      ysb_dimensi_id: form2.ysb_dimensi_id,
      ysb_semester_id: form2.ysb_semester_id,
      ysb_element_id: elementId,
      user_id: output_id_user
    };

    try {
      if (recapId === "default") {
        await APILA.put("/api/element-recap-head-values/default", payload, fetchParams);
        await GetResponseData();
        ToastSuccess.fire({ icon: "success", title: "Nilai berhasil disimpan" });
        return;
      }

      await APILA.put(`/api/element-recap-head-values/${recapId}`, payload, fetchParams);
      ToastSuccess.fire({ icon: "success", title: "Nilai berhasil diupdate" });
    } catch (err) {
      ToastError.fire({ icon: "error", title: "Gagal menyimpan nilai" });
    }
  };


  // =========================
    // MODAL KUNCI NILAI
    // =========================
    const [showModal, setShowModal] = useState(false);
  
    const handleOpenModal = () => {
      if (!form2.ysb_semester_id || !form2.ysb_school_id) {
        swal({
          title: "Data belum lengkap",
          text: "Semester dan Sekolah wajib dipilih",
          icon: "warning",
        });
        return;
      }
      setShowModal(true);
    };
  
    // =========================
    // MODAL CANCEL KUNCI NILAI
    // =========================
    const [showCancelModal, setShowCancelModal] = useState(false);
  
    const handleOpenCancelModal = () => {
      if (!form2.ysb_semester_id || !form2.ysb_school_id) {
        swal({
          title: "Data belum lengkap",
          text: "Semester dan Sekolah wajib dipilih",
          icon: "warning",
        });
        return;
      }
      setShowCancelModal(true);
    };

  /* =========================
     RENDER
  ========================== */
  return (
    <>
      <style>{shimmerStyle}</style>

      <div className="body">
        <HeadPage />

        {/* <div className="body-content-menu">
            <div className="breadcrumb-header " style={{fontSize:"13px" }}>
                <nav aria-label="breadcrumb">
                    <ol className="breadcrumb">
                        <li className="breadcrumb-item"> <Link style={{textDecoration:"none"}} to="">Dashboard</Link>  </li>
                        <li className="breadcrumb-item iniaktif" > <span className='ml-2'> Penilaian</span> </li>
                    </ol>
                </nav>
            </div>
        </div> */}
          
        <div className="body-content">
            <div className='d-flex mb-4'>
                <div>
                    <button  className=" btn " style={{fontSize: '15px', padding:'5px 10px', marginTop: '-2px',borderRadius: "10px 10px 0px 0px"}}> <Link style={{textDecoration: "none", color: "#327dffff"}} to="/element-recaps-dimensi">Penilaian Guru</Link> </button>
                </div>
                <div className='ml-2'>
                    <button  className=" btn " style={{fontSize: '15px', padding:'5px 10px', marginTop: '-2px', borderRadius: "10px 10px 0px 0px", backgroundColor:"#076db5ff", color: "#fff"}}>Penilaian Kepala Sekolah</button>
                </div>
            </div>
            <hr style={{borderBottom: "1px solid #327dffff", marginTop: "-22px"}}/>
           
            {/* FILTER */}
            {isTabletOrMobile ? 
              <>
              <div className="title-page">
                  <Row style={{marginTop: "10px", padding:"0 12px"}}>
                    <select className="mr-2" aria-label="Default select example" name="ysb_semester_id" value={form2?.ysb_semester_id}  onChange={handleChange}
                      style={{
                        border: "1px solid #d9defa",
                        borderRadius: "12px",
                        fontSize: "14px",
                        padding: "10px 12px",
                        background: "#fff",
                      }}
                    >      
                      <option value="" hidden>{namaTA} (Semester {namaSmstr})</option>
                      {getDataSemesterMap.map((user,index) => (
                        <option key={index} value={user?.id} style={{textAlign:""}}>{user?.name_year} (Semester {user?.semester})</option>
                      ))}  
                    </select>
                  </Row>
              
                  <Row style={{marginTop: "10px", padding:"0 12px"}}>
                    <select className="mr-2" aria-label="Default select example" name="ysb_dimensi_id" value={form2?.ysb_dimensi_id}  onChange={handleChange} 
                      style={{
                          border: "1px solid #d9defa",
                          borderRadius: "12px",
                          fontSize: "14px",
                          padding: "10px 12px",
                          background: "#fff",
                        }}
                    >
                              
                    <option value="" hidden>Pilih Dimensi</option>
                      {getDataDimensi.map((user,index) => (
                        <option value={user?.id} style={{textAlign:""}}>{user?.name_dimensi}</option>
                      ))} 
                    </select>
                  </Row>
    
                                          
                  <Row style={{marginTop: "12px", padding:"0 12px"}}>
                    {/* <button onClick={handleCari} className=" btn " style={{fontSize: '13px', padding:'5px 10px', marginTop: '-2px', borderRadius:"0", backgroundColor:"#eca91aff", color: "#fff"}}> Cari</button> */}
                    <button
                      onClick={handleCari}
                      disabled={!isFilterComplete}
                      title={!isFilterComplete ? "Lengkapi dan ubah filter terlebih dahulu" : ""}
                      className="btn"
                      style={{
                        fontSize: "13px",
                        padding: "10px 12px",
                        border: "1px solid #d9defa",
                        borderRadius: "12px",
                        backgroundColor: isFilterComplete ? "#eca91aff" : "#b6b6b6ff",
                        color: "#fff",
                        cursor: isFilterComplete ? "pointer" : "not-allowed",
                        opacity: isFilterComplete ? 1 : 0.6
                      }}
                    >
                      Cari
                    </button>
                  </Row>
                </div>
              </>
              :
              <>
              <div className="mb-3">
                {loading ? (
                  <>
                    <div className="mb-3 d-flex">
                      <div className="shimmer shimmer-select mr-2" style={{width:180, borderRadius: "12px"}} />
                      <div className="shimmer shimmer-select mr-2" style={{width:220, borderRadius: "12px"}} />
                      <div className="shimmer shimmer-select mr-2" style={{width:220, borderRadius: "12px"}} />
                    </div>
                    
                    <div className="d-flex">
                       <div className="shimmer shimmer-select mr-2" style={{width:150, borderRadius: "12px"}} />
                       <div className="shimmer shimmer-select mr-2" style={{width:50, borderRadius: "12px"}} />
                       <div className="shimmer shimmer-select mr-2" style={{width:70, borderRadius: "12px"}} />
                    </div>
                  </>
                ) : (
                  <div className="mb-3 mt-4">
                    <div className="d-flex">
                      <select className="mr-2" aria-label="Default select example" name="ysb_semester_id" value={form2?.ysb_semester_id} onChange={handleChange} 
                      style={{
                        border: "1px solid #d9defa",
                        borderRadius: "12px",
                        fontSize: "14px",
                        padding: "10px 12px",
                        background: "#fff",
                      }}
                      >
                        <option value="" hidden>{namaTA} (Semester {namaSmstr})</option>
                        {getDataSemesterMap.map((user,index) => (
                          <option key={index} value={user?.id} style={{textAlign:""}}>{user?.name_year} (Semester {user?.semester})</option>
                        ))}  
      
                      </select>
      
                      <select className="mr-2" aria-label="Default select example" onChange={handleChange} value={form2?.ysb_branch_id}  name="ysb_branch_id" 
                        style={{
                          border: "1px solid #d9defa",
                          borderRadius: "12px",
                          fontSize: "14px",
                          padding: "10px 12px",
                          background: "#fff",
                        }}
                      >
                        <option value="" hidden>Pilih Cabang</option>
                        {getDataBranch.map((user,index) => (
                          <option value={user?.branch_code} style={{textAlign:""}}>{user?.branch_name}</option>
                        ))}      
                      </select>
      
                      {/* <select className="mr-2" aria-label="Default select example" onChange={handleChange} value={form2?.ysb_school_id}  name="ysb_school_id" style={{ border: "1px solid #3f5bea", borderRadius: "3px", fontSize: '14px', padding:'5px 5px'}}>
                        <option value="" hidden>Pilih Sekolah</option>
                        {getDataSchool
                        .filter((user) => user.school_code !== "BASEMENT_BEKASI")  
                        .map((user, index) => (
                          <option key={index} value={user?.school_code}>
                            {user?.school_name}
                          </option>
                        ))
                      }
                      </select> */}

                        <select
                            className="mr-2"
                            name="ysb_school_id"
                            value={form2.ysb_school_id}
                            onChange={handleChange}
                            disabled={loadingSchool}
                            style={{
                              border: "1px solid #d9defa",
                              borderRadius: "12px",
                              fontSize: "14px",
                              padding: "10px 12px",
                              backgroundColor: loadingSchool ? "#f5f5f5" : "#fff",
                              cursor: loadingSchool ? "not-allowed" : "pointer",
                            }}

                          >
                            <option value="" hidden>
                              {loadingSchool ? "Memuat data sekolah..." : "Pilih Sekolah"}
                            </option>

                            {!loadingSchool &&
                              getDataSchool.map((user, index) => (
                                <option key={index} value={user?.school_code}>
                                  {user?.school_name}
                                </option>
                              ))}
                        </select>
      
                    </div>
                    <div className='mt-3 d-flex'>
                      <select className="mr-2" aria-label="Default select example" onChange={handleChange} value={form2?.ysb_dimensi_id}  name="ysb_dimensi_id" 
                      style={{
                        border: "1px solid #d9defa",
                        borderRadius: "12px",
                        fontSize: "14px",
                        padding: "10px 12px",
                        background: "#fff",
                      }}
                      >
                        <option value="" hidden>Pilih Dimensi</option>
                        {getDataDimensi.map((user,index) => (
                          <option value={user?.id} style={{textAlign:""}}>{user?.name_dimensi}</option>
                        ))}      
                      </select>

                      <button
                        onClick={handleCari}
                        disabled={!isFilterComplete}
                        title={!isFilterComplete ? "Lengkapi dan ubah filter terlebih dahulu" : ""}
                        className="btn"
                        style={{
                          fontSize: "13px",
                          padding: "10px 16px",
                          borderRadius: "12px",
                          backgroundColor: isFilterComplete ? "#eca91aff" : "#b6b6b6ff",
                          color: "#fff",
                          cursor: isFilterComplete ? "pointer" : "not-allowed",
                          opacity: isFilterComplete ? 1 : 0.6
                        }}
                      >
                        Cari
                      </button>

                      {/* <button className="btn ml-2" style={{fontSize: '13px', padding:'5px 10px', marginTop: '-2px', borderRadius:"3px", backgroundColor:"#1ab4ecff", color: "#fff"}}> Kunci Nilai </button> */}

                       <button className="btn ml-2" onClick={() => handleOpenModal()} style={{fontSize: '13px', padding: "10px 16px", borderRadius: "12px",   backgroundColor:"#1ab4ecff", color: "#fff"}}><FontAwesomeIcon icon={faKey} /> Kunci Nilai </button>
                      
                      <button className="btn ml-2" onClick={() => handleOpenCancelModal()} style={{fontSize: '13px', padding: "10px 16px", borderRadius: "12px",  backgroundColor:"#ec8a1aff", color: "#fff"}}> Cancel Kunci </button>

                    </div>
                  </div>
                )
              }
            </div>

                
              </>
            }
  
          {isFetching && (
            <div className="text-center" style={{ padding: "10px 0" }}>
              <span style={{color: "#2e52aeff", fontWeight: "500"}}><PulseLoader color={'#3f5bea'} size={12}/></span>
            </div>
          )}

          {hasSearched && !isFetching && getData.length > 0 && (
            <Tabs  activeKey={selectedTab}
            onSelect={(k) => setSelectedTab(k)}
            className="mt-4 nav-tabs"> 
                
              {(getData?.[0]?.data_element || [] ).map((element, eIdx) => (
                <Tab key={element?.id || eIdx} eventKey={element?.name_element} title={element?.name_element} className="nav-item">
                  <div className="text-center" style={{ marginTop: "10px", marginBottom: "20px", backgroundColor: "#9fd5ffff", padding: "5px 0px" }}>
                    <h5 className="mt-2 mb-2">{element?.description}</h5>
                  </div>
      
                  {/* TABLE */}
                  <Col xl='12' sm='12'>
                    <div className="mt-3">
                      <div className="body-table">
                        <div className="">
                        <table className="table table-laporan-adab  table-hover table-bordered " id="basic-datatable">
                            <thead>
                              <tr>
                                  <th className="border border-gray-300 p-3 bg-gray-100 text-center">Nama Kegiatan</th>
                                  <th className="border border-gray-300 p-3 bg-gray-100 text-center">Rata-Rata Penilaian Guru</th>
                                  <th className="border border-gray-300 p-3 bg-gray-100 text-center">Nilai</th>
                              </tr>
                            </thead>
                            <tbody>
                              {element?.rekapan?.map((rekap, idx) => (
                                <tr >
                                  <th style={{border: "1px solid #e0e0e0ff", lineHeight: "2", fontSize: "14px", fontWeight: "400"}} key={rekap?.ysb_sub_element_id || idx}>{rekap?.ysb_sub_element_name || rekap?.description}</th>
                                  {/* <td>{rekap.ysb_sub_element_value_teacher_average} </td> */}
                                  <td
                                    style={{
                                      textAlign: "center",
                                      verticalAlign: "middle",
                                      fontWeight: "500",
                                      color:
                                        rekap?.ysb_sub_element_status === 0
                                          ? "#dc3545"
                                          : "#000"
                                    }}
                                  >
                                    {rekap?.ysb_sub_element_value_teacher_average}
                                  </td>

                                  <td style={{ textAlign: "center" }}>
                                      <div
                                        style={{
                                          position: "relative",
                                          width: "60px",
                                          height: "38px",
                                          margin: "0 auto"
                                        }}
                                      >
                                        <input
                                          type="number"
                                          className="form-control text-center"
                                          value={rekap?.ysb_sub_element_value ?? ""}
                                          disabled={rekap?.ysb_sub_element_status === 0 || isPengawasAdab} 
                                          onChange={(e) => {
                                            if (rekap?.ysb_sub_element_status === 0 || isPengawasAdab) return;
                                            handleChangeNilaiLocal(e, element.id, rekap);
                                          }}
                                          onBlur={(e) => {
                                            if (rekap?.ysb_sub_element_status === 0 || isPengawasAdab) return;
                                            handleBlurNilai(e, element.id, rekap);
                                          }}
                                          style={{
                                            height: "38px",
                                            backgroundColor:
                                              rekap?.ysb_sub_element_status === 0 || isPengawasAdab
                                                ? "#f7f7f7ff"
                                                : "transparent",
                                            cursor:
                                              rekap?.ysb_sub_element_status === 0 || isPengawasAdab
                                                ? "not-allowed"
                                                : "text",
                                            border: "none"
                                          }}
/>
                                          {/* <input
                                          type="text"
                                          className="form-control text-center"
                                          value={rekap?.ysb_sub_element_value ?? ""}
                                          disabled={rekap?.ysb_sub_element_status === 0} 
                                          onChange={(e) => {
                                            if (rekap?.ysb_sub_element_status === 0) return;
                                            handleChangeNilaiLocal(e, element.id, rekap);
                                          }}
                                          onBlur={(e) => {
                                            if (rekap?.ysb_sub_element_status === 0) return;
                                            handleBlurNilai(e, element.id, rekap);
                                          }}
                                          style={{
                                            height: "38px",
                                            backgroundColor:
                                              rekap?.ysb_sub_element_status === 0
                                                ? "#f7f7f7ff"
                                                : "transparent",
                                            cursor:
                                              rekap?.ysb_sub_element_status === 0
                                                ? "not-allowed"
                                                : "text",
                                            border: "none"
                                          }}
                                        />

                                        
                                        {rekap?.ysb_sub_element_status === 0 && (
                                          <div
                                            style={{
                                              position: "absolute",
                                              inset: 0,
                                              display: "flex",
                                              alignItems: "center",
                                              justifyContent: "center",
                                              pointerEvents: "none"
                                            }}
                                          >
                                            <FontAwesomeIcon
                                              icon={faLock}
                                              style={{ color: "#9e9e9e", fontSize: "14px" }}
                                            />
                                          </div>
                                        )} */}
                                      </div>
                                    </td>
      
                                </tr>
                              ))}
                            </tbody>
                          </table>
                        </div>
                      </div>
                    </div>
                  </Col>

                  <Confirm
                    show={showModal}
                    onHide={() => setShowModal(false)}
                    payload={{
                      ysb_semester_id: form2.ysb_semester_id,
                      ysb_school_id: form2.ysb_school_id,
                      user_id: output_id_user,
                    }}
                    onSuccess={() => {
                      GetResponseData();
                    }}
                  />

                  <CancelNilai
                    show={showCancelModal}
                    onHide={() => setShowCancelModal(false)}
                    payload={{
                      ysb_semester_id: form2.ysb_semester_id,
                      ysb_school_id: form2.ysb_school_id,
                      user_id: output_id_user,
                    }}
                    onSuccess={() => {
                      GetResponseData(); 
                    }}
                  />
                </Tab>
              ))}
      
            </Tabs>
          )}
          
        </div>
      </div>

    </>
    
     
  );
}
